<template>
    <div class="tw-snap-center tw-flex tw-flex-col tw-group tw-py-3 tw-w-full dark:tw-border-[#223F57] tw-inline">
        <div class="tw-flex tw-flex-row tw-items-center">
            <!-- Thumbnail Section -->
            <div class="tw-no-underline tw-flex tw-flex-col tw-w-[104px] sm:tw-w-[142px] tw-flex-shrink-0 tw-mr-3 tw-aspect-video tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-lg"></div>
            <!-- Description Section -->
            <div class="tw-flex tw-w-full">
                <div class="tw-w-full tw-flex tw-flex-wrap lg:tw-block">
                    <div class="card-info tw-flex tw-flex-auto tw-flex-col tw-rounded-lg tw-justify-center tw-pt-1">
                        <div class="tw-flex tw-flex-col">
                            <!-- Video Title -->
                            <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-40 tw-h-5 tw-mb-1"></div>
                            <!-- Content -->
                            <div class="tw-flex tw-items-center tw-flex-wrap tw-text-[#3F3F46] dark:tw-text-[#9EC0DC]">
                                <div class="tw-w-20 tw-h-4 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-mb-1"></div>
                                <span class="tw-mx-1 tw-text-base tw-leading-none">·</span>
                                <div class="tw-w-20 tw-h-4 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full"></div>
                                <span class="tw-mx-1 tw-text-base tw-leading-none">·</span>
                                <div class="tw-mb-0.5 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-14 tw-h-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-inline-flex tw-items-start tw-pt-1 tw-px-1 tw-relative">
                    <div class="tw-relative tw-my-auto">
                        <div class="tw-w-4 tw-h-4 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
